export default "__VITE_ASSET__DGDXvZO8__"